/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryListGnb from './CategoryListGnb';

/**
 * The CategoryListRes model module.
 * @module model/CategoryListRes
 * @version 1.0
 */
class CategoryListRes {
    /**
     * Constructs a new <code>CategoryListRes</code>.
     * @alias module:model/CategoryListRes
     */
    constructor() { 
        
        CategoryListRes.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CategoryListRes</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryListRes} obj Optional instance to populate.
     * @return {module:model/CategoryListRes} The populated <code>CategoryListRes</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryListRes();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('categoryList')) {
                obj['categoryList'] = ApiClient.convertToType(data['categoryList'], [CategoryListGnb]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CategoryListRes</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CategoryListRes</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['categoryList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['categoryList'])) {
                throw new Error("Expected the field `categoryList` to be an array in the JSON data but got " + data['categoryList']);
            }
            // validate the optional field `categoryList` (array)
            for (const item of data['categoryList']) {
                CategoryListGnb.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
CategoryListRes.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
CategoryListRes.prototype['code'] = undefined;

/**
 * @member {String} description
 */
CategoryListRes.prototype['description'] = undefined;

/**
 * @member {Array.<module:model/CategoryListGnb>} categoryList
 */
CategoryListRes.prototype['categoryList'] = undefined;






export default CategoryListRes;

